import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DotIndicatorComponent } from './dot-indicator.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		MatTooltipModule,
		TranslateModule
	],
	declarations: [
		DotIndicatorComponent
	],
	exports: [
		DotIndicatorComponent
	]
})
export class DotIndicatorModule {}
